
  import {defineComponent} from "vue";

  export default defineComponent({
    name: 'ticket-message-component',
    props: ['productImageUrl','message','ordererName']
  });
